import React, { useMemo } from 'react';
import { getItemIconInlineSVG, hasItemIcon } from '../../rendering/items/ItemIconRegistry';

interface ItemIconProps {
  itemId: string;
  size?: number;
}

/**
 * Renders a procedural SVG icon for an item.
 * Falls back to a generic icon if no custom SVG exists.
 *
 * The `__html` object is memoised: React 19 re-applies `dangerouslySetInnerHTML`
 * whenever the object changes, so a fresh object per render replaced the SVG
 * nodes on every parent re-render. A bag slot re-renders on mousedown (its
 * pressed style), so the node under the pointer was gone by mouseup and the
 * browser fired no click: clicking a bag item never selected it (lane BI).
 */
export const ItemIcon: React.FC<ItemIconProps> = ({ itemId, size = 24 }) => {
  const html = useMemo(() => ({ __html: getItemIconInlineSVG(itemId, size) }), [itemId, size]);
  return (
    <span
      dangerouslySetInnerHTML={html}
      style={{ display: 'inline-flex', width: size, height: size, alignItems: 'center', justifyContent: 'center' }}
    />
  );
};

export { hasItemIcon };
